/* eslint-disable */
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import styles from './InspectionScriptPopup.css';

const debug = _debug('app:InspectionScriptPopup');

class InspectionScriptPopup extends Component {

  static propTypes = {
    openPopup: React.PropTypes.bool,
    wholeData: React.PropTypes.shape({}),
    togglePopupInspectionScript: React.PropTypes.func,
    systemsettings: React.PropTypes.object,
    strings: React.PropTypes.shape({}),
    currentLanguage: React.PropTypes.string
  };

  constructor(props) {
    super(props);
    debug(props);
    this.state = {
      isOpen: this.props.openPopup
    };
  }

  handleToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
    this.props.togglePopupInspectionScript();
  }

  checkScript = (CourtesyCallScript) => {
    let dataValue = CourtesyCallScript;
    const inspectionData = this.props.wholeData;
    const { strings } = this.props;
    let paymentType = '';
    if (inspectionData.cica_recurringpaymenttype === 'Checking') {
      paymentType = strings.checking
    } else if (inspectionData.cica_recurringpaymenttype=== 'Credit or Debit') {
      paymentType = strings.creditDebitCard
    } else {
      paymentType = inspectionData.cica_recurringpaymenttype;
    }
    if (inspectionData.cica_premiummode == 'Annually' || inspectionData.cica_premiummode == 'annually') {

          dataValue = dataValue.replace(/%name%/g, inspectionData.cica_customerFirstLastname)
      .replace(/%directorName%/g, inspectionData.cica_writingagentsmanagerFirstLastName)
      .replace(/%policyName%/g, inspectionData.product)
      .replace(/%date%/g, inspectionData.cica_appdate)
      .replace(/%position%/g, inspectionData.cica_occupation)
      .replace(/%agentName%/g, inspectionData.cica_writingagentFirstLastName)
      .replace(/%amount%/g, 'NA')
      .replace(/%account%/g, 'NA')
      .replace(/%phoneNumber%/g, inspectionData.phoneNumber)
      .replace(/%billingDate%/g, 'NA');

    } else {

          dataValue = dataValue.replace(/%name%/g, inspectionData.cica_customerFirstLastname)
      .replace(/%directorName%/g, inspectionData.cica_writingagentsmanagerFirstLastName)
      .replace(/%policyName%/g, inspectionData.product)
      .replace(/%date%/g, inspectionData.cica_appdate)
      .replace(/%position%/g, inspectionData.cica_occupation)
      .replace(/%agentName%/g, inspectionData.cica_writingagentFirstLastName)
      .replace(/%amount%/g, inspectionData.cica_monthlypremiuim)
      .replace(/%account%/g, paymentType)
      .replace(/%phoneNumber%/g, inspectionData.phoneNumber)
      .replace(/%billingDate%/g, inspectionData.cica_premiumbillingdate);

    }

    return dataValue;
  }

  render() {
    const { systemsettings, strings, currentLanguage } = this.props;
    console.log('this.context.currentLanguage', currentLanguage);
    console.log('this.context.systemsettings', systemsettings);
    let scriptText = '';
    let scriptObject = {};
    if (currentLanguage === "en") {
      console.log('this.context.currentLanguage +*(E*(@E*()Q*E)(*#R()#*R)(');
      scriptObject = systemsettings && systemsettings.find((current) => current.cica_category === '11' && current.cica_name == '1');
      console.log('scriptObject', scriptObject);
      scriptText = scriptObject.cica_description;
    }
    else {
      scriptObject = systemsettings && systemsettings.find((current) => current.cica_category === '11' && current.cica_name == '2');
      scriptText = scriptObject.cica_description;
    }


    // const scriptText = `<p>Hello Mr./Mrs. <b>%name%</b>, my name is  <u>____</u>   and I am the <u>____</u>  for Combined Insurance in <u>____</u>. From time to time I call new policyholders to welcome them to Combined Insurance and to ensure that we have met all of your expectations. I understand you purchased a(n) <b>%policyName%</b> policy from agent <b>%agentName%</b> on <b>%date%</b>, is that correct? <i>(Solidify the sale by reinforcing the benefits their policy offers.)</i></p><ol><li>Do you have any questions about the policy?</li><li>Do you understand that the policy is not intended to replace any existing coverage you may have?</li><li>We want each policyholder to understand the amount of their payment and when they will be billed moving forward.  The monthly premium on your policy is <b>%amount%</b> and should occur on or about the <b>%billingDate%</b>  of each month. The monthly premium will be deducted from your <b>%account%</b>.  Are you comfortable with this?<i>(Address any concerns that the customer may have.)</i><ol type="a" style="font-style: italic;"><li>If customer isn't sure, explain: Some of our policyholders think a good rule of thumb is limiting their premium for a supplemental policy to around one hour of pay per week, multiplied by four weeks.  So, a person earning $20 per hour x 4 weeks would plan to pay about $80 per month for a supplement policy.</li></ol><li>Were you happy with the service you received from <b>%agentName%</b> ?  How would you rate <b>%agentName%</b> on a scale from 1 to 5, with 5 being the highest rating?</li><li>Do you know of anyone else that may benefit from the products we offer?</li></ol><p>Thank you for your time. Please feel free to call me or email me with any questions.</p><p style="font-weight: bold;">NOTE: Call Field Compliance immediately to report any Policyholder feedback which indicates a possible violation of company or industry standards at 518-786-7187.</p><hr style="border: 1px solid #395d86;"><h4 style="color: #0b6aa8;"> INSPECTION VOICEMAIL SCRIPT</h4><p>Hello Mr./Mrs. <b>%name%</b>, my name is <u>____</u>  and I am the <u>____</u>  for Combined Insurance in <u>____</u>. Our local agent, <b>%agentName%</b> has submitted your policy to our underwriting department and if your application is approved your policy should be issued quickly.</p><p>In line with that, your first payment of <b>%amount%</b> will be deducted immediately and future monthly deductions will happen on or around the <b>%billingDate%</b>  of each month.</p><p>As your local manager, it's important to me that you understand your coverage and that you're happy with the service that our agent provided. If I can be of any assistance, please call me at <u>Your Number</u>. Or, you may call our customer service line at +1-800-225-4500. Again, my name is <u>Your Name</u> and I'd like to be the first to welcome you to Combined Insurance.</p>`;
    return (
      <Modal
        isOpen={this.state.isOpen}
        className="modalClass"
        overlayClassName="overlayClass"
      >
        <div className={styles.scriptPopupcontainer}>
          <div className={styles.popupVeryBig}>
            <div className={styles.closeHeader}>
              <span className={styles.inspectionscriptLable}>{strings.inspectionScriptHeader}</span>
              <div className={styles.closeButton}>
                <input
                  type="image"
                  src="static/popup_close_btn.png"
                  alt="Close"
                  className={styles.closeButton1}
                  onClick={(evt) => {
                    evt.preventDefault();
                    this.handleToggle();
                  }}
                />
              </div>
            </div>
            <div className={styles.textAlign}>
              {ReactHtmlParser(this.checkScript(scriptText))}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  systemsettings: state.assign.systemsettings
});
export default connect(mapStateToProps)(InspectionScriptPopup);



// WEBPACK FOOTER //
// ./src/components/InspectionScriptPopup/InspectionScriptPopup.js